import { useRef } from 'react';
import DataTable from 'src/components/DataTable';
import { DataTableNotFoundMode, IDataTableRef } from 'src/components/DataTable/shared/types';
import { translate } from 'src/locales/i18next/config';
import Translations from 'src/locales/i18next/translations/translation';
import FlashProductsFilter from '../components/FlashProductsFilter';
import useFlashProductsColumns from '../helpers/colum-definitions/use-flash-products-columns';
import flashProductsResponseAdapter from '../services/adapter/flash-products-response-adapter';
import { getFlashDiscountProducts, getFlashDiscountProductsQueryKey } from '../services/api/get-flash-discount-products';
import FlashProductsTabs from '../tabs';

export default function FlashProductsPage() {
  const t = translate(Translations);
  const translation = 'pages.flashProducts';

  const dataTableRef = useRef<IDataTableRef>(null);

  const columns = useFlashProductsColumns(dataTableRef);
  
  const initialValues = {
    pagination: { pageSize: 50 },
  };

  if (!columns.length) return null;
  return (
    <>
      <div>
        <h3 className="mb-7">{t(`${translation}.flashProducts`)}</h3>

        <div className="card card-custom mb-4">
          <FlashProductsTabs />

          <div className="card-body">
            <div className="tab-content pt-3">
              <div className="tab-pane active">
                <FlashProductsFilter dataTableRef={dataTableRef} />
              </div>

              <DataTable
                ref={dataTableRef}
                columns={columns}
                queryKey={getFlashDiscountProductsQueryKey}
                queryFn={getFlashDiscountProducts}
                responseAdapter={flashProductsResponseAdapter}
                initial={initialValues}
                filterSerializer={(_filters) => {
                  const filters = Object.assign({}, _filters);

                  filters.brandId = filters.brandId?.map((e: any) => e.value);

                  if (filters.categoryId && typeof filters.categoryId === 'string') {
                    filters.categoryId = filters.categoryId.split(',');
                  }

                  if (filters.brandId && typeof filters.brandId === 'string') {
                    filters.brandId = filters.brandId.split(',');
                  }

                  return filters;
                }}
                notFoundOptions={{
                  mode: DataTableNotFoundMode.showWithinTable,
                  title: 'Aradığınız özelliklere uygun ürün şu anda listelenmemektedir.',
                  description: '"Kampanya Oluştur" ile kendi kampanyanızı başlatabilirsiniz.',
                  actionBtn: {
                    label: 'Kampanya Oluştur',
                    slug: '/campaigns/create',
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
